const MESSAGE_CODE_TYPE_MAP = {
  "0": "image",
  "1": "recording",
  "2": "video",
  "3": "videoBubble",
};

const MEDIA_TYPES = ["image", "video", "recording", "videoBubble"];

export function resolveChatMessageType(item) {
  const code = String(item?.message ?? "").trim();
  const fromCode = MESSAGE_CODE_TYPE_MAP[code];
  const hasMediaUrl = Boolean(item?.url || item?.bubbleUrl || item?.thumbnailUrl);
  const apiType = item?.type;

  if (fromCode && (hasMediaUrl || MEDIA_TYPES.includes(apiType))) {
    return fromCode;
  }

  if (MEDIA_TYPES.includes(apiType)) {
    return apiType;
  }

  return apiType || "message";
}

export function getChatMediaLinks(item) {
  const type = resolveChatMessageType(item);
  const url = item?.url || "";
  const bubbleUrl = item?.bubbleUrl || item?.bubbleVideo || "";
  const thumbnailUrl =
    item?.thumbnailUrl || item?.videoUrl || item?.coverUrl || "";

  if (type === "videoBubble") {
    // Prefer dedicated bubble + background video when API sends both
    const bubbleLink = bubbleUrl || url;
    const mediaLink = thumbnailUrl || (bubbleUrl ? url : "") || url;
    return {
      mediaLink,
      bubbleLink,
    };
  }

  return {
    mediaLink: url,
    bubbleLink: "",
  };
}
